import {
  ArcElement,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  PointElement,
  RadialLinearScale,
  Tooltip,
} from 'chart.js';

// Register only what the radial charts (PolarArea, Radar) need — keeps the
// chart.js tree-shaken footprint minimal. Imported once for its side effects.
let registered = false;

export function registerCharts(): void {
  if (registered) return;
  ChartJS.register(
    RadialLinearScale,
    ArcElement,
    PointElement,
    LineElement,
    Filler,
    Legend,
    Tooltip,
  );
  registered = true;
}
